/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { i as isWeb, a as isKuaiShouMiniProgram, b as isWeChatMiniProgram, c as isByteDanceMicroApp, d as isMiniApp, e as isBaiduSmartProgram } from './index-892d8eee.js';
import { c as createCommonjsModule, a as getDefaultExportFromCjs } from './_commonjsHelpers-56d33373.js';

function isUndef(type) {
  return type === 'undefined';
}

var isDingdingMiniapp = !isUndef(typeof dd) && dd !== null && !isUndef(typeof dd.alert);

var CONTAINER_NAME = {
  WECHAT: 'wechatMiniProgram',
  ALIPAY: 'aliMiniApp',
  BYTE: 'bytedanceMicroApp',
  WEB: 'web',
  BAIDU: 'baiduSmartProgram',
  KWAI: 'kuaishouMiniProgram'
};

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

function promisify$1(api) {
  return function (arg) {
    return new Promise(function (resolve, reject) {
      var promisifyArg = arg;
      api(_extends$b({}, promisifyArg, {
        success: function success(res) {
          if (promisifyArg && typeof promisifyArg.success === 'function') {
            promisifyArg.success(res);
          }

          resolve(res);
        },
        onSuccess: function onSuccess(res) {
          if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
            promisifyArg.onSuccess(res);
          }

          resolve(res);
        },
        fail: function fail(res) {
          if (promisifyArg && typeof promisifyArg.fail === 'function') {
            promisifyArg.fail(res);
          }

          reject(res);
        },
        onFail: function onFail(res) {
          if (promisifyArg && typeof promisifyArg.onFail === 'function') {
            promisifyArg.onFail(res);
          }

          reject(res);
        },
        complete: function complete(res) {
          if (promisifyArg && typeof promisifyArg.complete === 'function') {
            promisifyArg.complete(res);
          }
        },
        onComplete: function onComplete(res) {
          if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
            promisifyArg.onComplete(res);
          }
        }
      }));
    });
  };
}

var _excluded = ["_ext"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
var styleIn = function styleIn(options, baseName) {
  var _ref = options || {},
      _ref$_ext = _ref._ext,
      _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return _extends$a({}, rest, _ext[baseName] || {});
};

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
var normalize = {
  chooseImage: function chooseImage(api, containerName) {
    var formatResponse = function formatResponse(res) {
      return _extends$9({}, res, {
        tempFiles: res.tempFiles || res.files,
        tempFilePaths: res.tempFilePaths
      });
    };

    return function (args) {
      args = styleIn(args, containerName);
      return promisify$1(api)(_extends$9({}, args, {
        count: args.count || 1,
        success: function success(res) {
          args.success && args.success(formatResponse(res));
        },
        complete: function complete(res) {
          args.complete && args.complete(res);
        }
      })).then(formatResponse);
    };
  },
  compressImage: function compressImage(api, containerName) {
    var formatResponse = function formatResponse(res) {
      return {
        tempFilePath: res.tempFilePath || (res.filePaths || [])[0] || (res.apFilePaths || [])[0] || ''
      };
    };

    return function (args) {
      args = styleIn(args, containerName);
      return promisify$1(api)(_extends$9({}, args, {
        success: function success(res) {
          args.success && args.success(formatResponse(res));
        },
        complete: function complete(res) {
          args.complete && args.complete(res);
        }
      })).then(formatResponse);
    };
  },
  getImageInfo: function getImageInfo(api, containerName) {
    return function (args) {
      return promisify$1(api)(styleIn(args, containerName));
    };
  },
  previewImage: function previewImage(api, containerName) {
    return function (args) {
      return promisify$1(api)(styleIn(args, containerName));
    };
  },
  saveImage: function saveImage(api, containerName) {
    return function (args) {
      return promisify$1(api)(styleIn(args, containerName));
    };
  }
};

var chooseImage$b = normalize.chooseImage(function (args) {
  return isDingdingMiniapp ? dd.chooseImage(args) : my.chooseImage(args);
}, CONTAINER_NAME.ALIPAY);
var chooseImage$c = chooseImage$b;

var compressImage$6 = normalize.compressImage(function (args) {
  if (isDingdingMiniapp) {
    args.filePaths = [args.src];
  } else {
    args.apFilePaths = [args.src];
  }

  args && typeof args.quality === 'number' && (args.compressLevel = args.quality);
  return isDingdingMiniapp ? dd.compressImage(args) : my.compressImage(args);
}, CONTAINER_NAME.ALIPAY);

var getImageInfo$b = normalize.getImageInfo(function (args) {
  return isDingdingMiniapp ? dd.getImageInfo(args) : my.getImageInfo(args);
}, CONTAINER_NAME.ALIPAY);
var getImageInfo$c = getImageInfo$b;

var previewImage$b = normalize.previewImage(function (args) {
  return isDingdingMiniapp ? dd.previewImage(args) : my.previewImage(args);
}, CONTAINER_NAME.ALIPAY);
var previewImage$c = previewImage$b;

var saveImage$b = normalize.saveImage(function (args) {
  return isDingdingMiniapp ? dd.saveImage(args) : my.saveImage(args);
}, CONTAINER_NAME.ALIPAY);
var saveImage$c = saveImage$b;

var aliMiniAppModule = {
  chooseImage: chooseImage$c,
  compressImage: compressImage$6,
  getImageInfo: getImageInfo$c,
  previewImage: previewImage$c,
  saveImage: saveImage$c
};

var constant = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.CONTAINER_NAME = void 0;
var CONTAINER_NAME = {
  WECHAT: 'wechatMiniProgram',
  ALIPAY: 'aliMiniApp',
  BYTE: 'bytedanceMicroApp',
  WEB: 'web',
  BAIDU: 'baiduSmartProgram',
  KWAI: 'kuaishouMiniProgram'
};
exports.CONTAINER_NAME = CONTAINER_NAME;
});

var promisify_2 = promisify;

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

function promisify(api) {
  return function (arg) {
    return new Promise(function (resolve, reject) {
      var promisifyArg = arg;
      api(_extends$8({}, promisifyArg, {
        success: function success(res) {
          if (promisifyArg && typeof promisifyArg.success === 'function') {
            promisifyArg.success(res);
          }

          resolve(res);
        },
        onSuccess: function onSuccess(res) {
          if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
            promisifyArg.onSuccess(res);
          }

          resolve(res);
        },
        fail: function fail(res) {
          if (promisifyArg && typeof promisifyArg.fail === 'function') {
            promisifyArg.fail(res);
          }

          reject(res);
        },
        onFail: function onFail(res) {
          if (promisifyArg && typeof promisifyArg.onFail === 'function') {
            promisifyArg.onFail(res);
          }

          reject(res);
        },
        complete: function complete(res) {
          if (promisifyArg && typeof promisifyArg.complete === 'function') {
            promisifyArg.complete(res);
          }
        },
        onComplete: function onComplete(res) {
          if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
            promisifyArg.onComplete(res);
          }
        }
      }));
    });
  };
}

var promisify_1 = /*#__PURE__*/Object.defineProperty({
	promisify: promisify_2
}, '__esModule', {value: true});

var styleOptions = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.styleIn = exports.styleOut = void 0;
var _excluded = ["_ext"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var styleOut = function styleOut(output, originalInput, originalOutput) {
  return _extends({}, output, {
    _original: {
      input: _extends({}, originalInput),
      // 实际调用 api 方法时传入的参数. 对入参进行 format 之后的结果
      output: _extends({}, originalOutput) // 实际调用 api 方法时传入的参数. 返回值 format 之前的结果

    }
  });
};

exports.styleOut = styleOut;

var styleIn = function styleIn(options, baseName) {
  var _ref = options || {},
      _ref$_ext = _ref._ext,
      _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return _extends({}, rest, _ext[baseName] || {});
};

exports.styleIn = styleIn;
});

var common = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.normalize = void 0;





function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var normalize = {
  chooseVideo: function chooseVideo(api, containerName) {
    var formatResponse = function formatResponse(res) {
      return _extends({}, res, {
        tempFilePath: res.tempFilePath || res.filePath
      });
    };

    return function (args) {
      args = (0, styleOptions.styleIn)(args, containerName);
      return (0, promisify_1.promisify)(api)(_extends({}, args, {
        success: function success(res) {
          args.success && args.success(formatResponse(res));
        },
        complete: function complete(res) {
          args.complete && args.complete(res);
        }
      })).then(formatResponse);
    };
  },
  chooseMedia: function chooseMedia(api, containerName) {
    var formatResponse = function formatResponse(res) {
      return _extends({}, res, {
        tempFiles: (res.tempFiles || res.files).map(function (item) {
          return _extends({}, item, {
            tempFilePath: item.tempFilePath || item.path
          });
        })
      });
    };

    return function (args) {
      if (args === void 0) {
        args = {};
      }

      args = (0, styleOptions.styleIn)(_extends({
        count: 9,
        sizeType: ['original', 'compressed'],
        sourceType: ['camera', 'album'],
        mediaType: ['image', 'video'],
        maxDuration: 60
      }, args), containerName);
      return (0, promisify_1.promisify)(api)(_extends({}, args, {
        success: function success(res) {
          args.success && args.success(formatResponse(res));
        },
        fail: function fail(res) {
          args.fail && args.fail(res);
        },
        complete: function complete(res) {
          args.complete && args.complete(res);
        }
      })).then(formatResponse);
    };
  }
};
exports.normalize = normalize;
});

var chooseMedia_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;





function inputCreateAndAppend(multiple, accept) {
  var inputElement = document.createElement('INPUT');
  inputElement.name = 'file';
  inputElement.id = "input-" + Math.random() * 1e8;
  inputElement.type = 'file';
  multiple && inputElement.setAttribute('multiple', 'multiple');
  inputElement.style.display = 'none';
  accept && inputElement.setAttribute('accept', accept);
  document.body.appendChild(inputElement);
  return inputElement;
}

var chooseMedia = common.normalize.chooseMedia(function (args) {
  if (args === void 0) {
    args = {};
  }

  var _args = args,
      _args$count = _args.count,
      count = _args$count === void 0 ? 9 : _args$count,
      _args$success = _args.success,
      success = _args$success === void 0 ? function () {} : _args$success,
      _args$fail = _args.fail,
      fail = _args$fail === void 0 ? function () {} : _args$fail,
      _args$complete = _args.complete,
      complete = _args$complete === void 0 ? function () {} : _args$complete;

  try {
    var inputElement = inputCreateAndAppend(count > 1, args.accept);
    var files = [];
    inputElement.addEventListener('change', function (e) {
      files = e.target.files && Array.from(e.target.files).slice(0, count);
      var res = {
        tempFiles: files.map(function (file) {
          return {
            tempFilePath: window.URL.createObjectURL(file),
            size: file.size
          };
        }),
        files: files
      };
      success(res);
      complete(res);
      inputElement.remove && inputElement.remove();
    }, false);
    var MouseEvents = document.createEvent('MouseEvents');
    MouseEvents.initEvent('click', true, true);
    inputElement.dispatchEvent(MouseEvents);
  } catch (e) {
    fail(e);
    complete(e);
  }
}, constant.CONTAINER_NAME.WEB);

var _default = chooseMedia;
exports.default = _default;
});

var chooseMedia = /*@__PURE__*/getDefaultExportFromCjs(chooseMedia_1);

var chooseImage$9 = normalize.chooseImage(function (args) {
  if (args === void 0) {
    args = {};
  }

  var _args = args,
      _args$count = _args.count,
      count = _args$count === void 0 ? 1 : _args$count,
      _args$success = _args.success,
      success = _args$success === void 0 ? function () {} : _args$success,
      _args$fail = _args.fail,
      fail = _args$fail === void 0 ? function () {} : _args$fail,
      _args$complete = _args.complete,
      complete = _args$complete === void 0 ? function () {} : _args$complete;
  chooseMedia({
    count: count,
    accept: 'image/*'
  }).then(function (res) {
    var result = {
      tempFilePaths: res.tempFiles.map(function (item) {
        return item.tempFilePath;
      }),
      tempFiles: res.tempFiles.map(function (item) {
        return {
          path: item.tempFilePath,
          size: item.size
        };
      }),
      files: res.files
    };
    success(result);
    complete(result);
  }).catch(function (e) {
    fail(e);
    complete(e);
  });
}, CONTAINER_NAME.WEB);
var chooseImage$a = chooseImage$9;

var compressImage$5 = function compressImage() {
  throw new Error('Uni API: compressImage不支持');
};

var getImageInfo$9 = normalize.getImageInfo(function (args) {
  var image = new Image();
  image.src = args.src;

  if (image.naturalWidth) {
    var res = {
      width: image.naturalWidth,
      height: image.naturalHeight,
      path: args.src
    };
    args.success(res);
    args.complete(res);
  } else {
    var setImageInfo = function setImageInfo() {
      var res = {
        width: image.width,
        height: image.height,
        path: args.src
      };
      args.success(res);
      args.complete(res);
    };

    if (image.complete) {
      setImageInfo();
    } else {
      var checkTimer = null;

      var clear = function clear() {
        clearInterval(checkTimer);
        checkTimer = null;
      };

      checkTimer = setInterval(function () {
        if (image.width > 0 || image.height > 0) {
          setImageInfo();
          clear();
        }
      }, 40);

      image.onload = function () {
        if (checkTimer) {
          setImageInfo();
          clear();
        }
      }; // eslint-disable-next-line no-multi-assign


      image.onabort = image.onerror = function (e) {
        args.fail(e);
        args.complete(e);
        clear();
      };
    }
  }
}, CONTAINER_NAME.WEB);
var getImageInfo$a = getImageInfo$9;

var clsPrefix = '__universal_preview_image';
var styles = ("." + clsPrefix + " {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  text-align: center;\n  background: #000;\n  box-sizing: border-box;\n  outline: none;\n  overflow: hidden;\n  animation-duration: .3s;\n  animation-fill-mode: both;\n}\n." + clsPrefix + "_pageindex {\n  position: absolute;\n  top: 12px;\n  left: 0;\n  right: 0;\n  text-align: center;\n  color: #fff;\n  font-size: 16px;\n  z-index: 2;\n}\n." + clsPrefix + "_swiper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  transition-property: transform;\n  box-sizing: content-box;\n}\n." + clsPrefix + "_item {\n  max-height: 70%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  width: 100%;\n  position: relative;\n  transition-property: transform;\n  overflow: hidden;\n}\n." + clsPrefix + "_img {\n  width: 100%;\n}\n@keyframes " + clsPrefix + "_fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes " + clsPrefix + "_fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}").replace(/\n/g, '');
var styleElement = null;
var previewImage$9 = normalize.previewImage(function (args) {
  var _ref = args || {},
      _ref$urls = _ref.urls,
      urls = _ref$urls === void 0 ? [] : _ref$urls;

  var _ref2 = args || {},
      _ref2$current = _ref2.current,
      current = _ref2$current === void 0 ? 0 : _ref2$current;

  if (Object.prototype.toString.call(urls) !== '[object Array]') {
    throw new Error('the arguments must contain urls that type is a Array');
  }

  if (urls.length <= 0) {
    throw new Error('the urls`s length is at least 1');
  }

  if (!Number.isSafeInteger(current)) {
    throw new Error('the current must be a safe integer');
  }

  current = Math.min(Math.max(current, 0), urls.length - 1);

  if (!styleElement) {
    // create a style tag for keyframes
    styleElement = document.createElement('style');
    styleElement.innerHTML = styles;
    document.body.appendChild(styleElement);
  }

  var containerEle = document.createElement('div');
  containerEle.className = clsPrefix;
  containerEle.style.animationName = clsPrefix + "_fadeIn";
  containerEle.addEventListener('click', function () {
    containerEle && (containerEle.style.animationName = clsPrefix + "_fadeOut");
    setTimeout(function () {
      containerEle && document.body.removeChild(containerEle);
      containerEle = null;
    }, 300);
  });
  var pageIndexEle = document.createElement('div');
  pageIndexEle.className = clsPrefix + "_pageindex";
  pageIndexEle.innerText = current + 1 + "/" + urls.length;
  containerEle.appendChild(pageIndexEle);
  var swiperEle = document.createElement('div');
  swiperEle.className = clsPrefix + "_swiper";
  var damp = 1;
  var clientWidth = document.documentElement.clientWidth;
  var startX = 0;
  swiperEle.addEventListener('touchstart', function (e) {
    if (e.touches.length > 1) {
      e.stopPropagation();
      e.preventDefault();
    }

    startX = e.targetTouches[0].pageX;
  });
  swiperEle.addEventListener('touchmove', function (e) {
    if (e.touches.length > 1) {
      e.stopPropagation();
      e.preventDefault();
    }

    var moveX = e.targetTouches[0].pageX - startX;
    swiperEle.style.transform = "translateX(" + (-clientWidth * current + moveX * damp) + "px)";
  });
  swiperEle.addEventListener('touchend', function (e) {
    var endX = e.changedTouches[0].pageX - startX;

    if (Math.abs(endX * damp) > clientWidth / 5) {
      current = endX < 0 ? Math.min(current + 1, urls.length - 1) : Math.max(current - 1, 0);
    }

    pageIndexEle.innerText = current + 1 + "/" + urls.length;
    var transitionDuration = 300;
    swiperEle.style.transitionDuration = transitionDuration + "ms";
    swiperEle.style.transform = "translateX(" + -clientWidth * current + "px)";
    setTimeout(function () {
      swiperEle.style.transitionDuration = '0ms';
    }, transitionDuration);
  });
  swiperEle.style.transform = "translateX(" + -clientWidth * current + "px)";
  containerEle.appendChild(swiperEle);
  urls.forEach(function (url) {
    var swiperItemEle = document.createElement('div');
    swiperItemEle.className = clsPrefix + "_item";
    swiperItemEle.addEventListener('click', function (e) {
      e.stopPropagation();
      containerEle && (containerEle.style.animationName = clsPrefix + "_fadeOut");
      setTimeout(function () {
        containerEle && document.body.removeChild(containerEle);
        containerEle = null;
      }, 300);
    });
    swiperEle.appendChild(swiperItemEle);
    var imageEle = document.createElement('img');
    imageEle.className = clsPrefix + "_img";
    imageEle.src = url;
    swiperItemEle.appendChild(imageEle);
    swiperItemEle.addEventListener('touchstart', function (e) {
      if (e.touches.length > 1) {
        e.stopPropagation();
        e.preventDefault();
        var point1 = e.touches[0];
        var point2 = e.touches[1];
        var xLen = Math.abs(point2.pageX - point1.pageX);
        var yLen = Math.abs(point2.pageY - point1.pageY);
        swiperItemEle.touchDistance = Math.sqrt(xLen * xLen + yLen * yLen);
      } else {
        swiperItemEle.touched = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        };
      }
    });
    swiperItemEle.addEventListener('touchmove', function (e) {
      if (e.touches.length > 1) {
        e.stopPropagation();
        e.preventDefault();
        var xLen = Math.abs(e.touches[0].pageX - e.touches[1].pageX);
        var yLen = Math.abs(e.touches[1].pageY - e.touches[1].pageY);
        var touchDistance = Math.sqrt(xLen * xLen + yLen * yLen);

        if (swiperItemEle.touchDistance) {
          var pinchScale = (swiperItemEle.previousPinchScale || 1) + (touchDistance - swiperItemEle.touchDistance) / swiperItemEle.touchDistance;
          var imageScale = Math.max(1, pinchScale);
          imageEle.style.transform = "scale(" + imageScale + ")";
          swiperItemEle.previousPinchScale = imageScale;
        }

        swiperItemEle.touchDistance = touchDistance;
      } else if (swiperItemEle.previousPinchScale > 1) {
        e.stopPropagation();
        var x = (swiperItemEle.preX || 0) + (e.touches[0].pageX - swiperItemEle.touched.x);
        var y = (swiperItemEle.preY || 0) + (e.touches[0].pageY - swiperItemEle.touched.y);
        imageEle.style.transform = "scale(" + swiperItemEle.previousPinchScale + ") translate(" + x + "px, " + y + "px)";
        swiperItemEle.preX = x;
        swiperItemEle.preY = y;
        swiperItemEle.touched = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        };
      }
    });
  });
  document.body.appendChild(containerEle);
}, CONTAINER_NAME.WEB);
var previewImage$a = previewImage$9;

var saveImage$9 = function saveImage() {
  throw new Error('Uni API: saveImage不支持');
};

var saveImage$a = saveImage$9;

var webModule = {
  chooseImage: chooseImage$a,
  compressImage: compressImage$5,
  getImageInfo: getImageInfo$a,
  previewImage: previewImage$a,
  saveImage: saveImage$a
};

var chooseImage$7 = normalize.chooseImage(function (args) {
  return wx.chooseImage(args);
}, CONTAINER_NAME.WECHAT);
var chooseImage$8 = chooseImage$7;

var compressImage$4 = normalize.compressImage(function (args) {
  args && typeof args.quality === 'number' && (args.quality = args.quality * 33);
  return wx.compressImage(args);
}, CONTAINER_NAME.WECHAT);

var getImageInfo$7 = normalize.getImageInfo(function (args) {
  return wx.getImageInfo(args);
}, CONTAINER_NAME.WECHAT);
var getImageInfo$8 = getImageInfo$7;

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
var previewImage$7 = normalize.previewImage(function (args) {
  wx.previewImage(_extends$7({}, args, {
    current: typeof args.current === 'number' ? args.urls[args.current] : args.urls[0]
  }));
}, CONTAINER_NAME.WECHAT);
var previewImage$8 = previewImage$7;

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
var saveImage$7 = normalize.saveImage(function (args) {
  wx.saveImageToPhotosAlbum(_extends$6({}, args, {
    filePath: args.url
  }));
}, CONTAINER_NAME.WECHAT);
var saveImage$8 = saveImage$7;

var weChatModule = {
  chooseImage: chooseImage$8,
  compressImage: compressImage$4,
  getImageInfo: getImageInfo$8,
  previewImage: previewImage$8,
  saveImage: saveImage$8
};

var chooseImage$5 = normalize.chooseImage(function (args) {
  return tt.chooseImage(args);
}, CONTAINER_NAME.BYTE);
var chooseImage$6 = chooseImage$5;

var compressImage$3 = normalize.compressImage(function (args) {
  args && typeof args.quality === 'number' && (args.quality = args.quality * 33);
  return tt.compressImage(args);
}, CONTAINER_NAME.BYTE);

var getImageInfo$5 = normalize.getImageInfo(function (args) {
  return tt.getImageInfo(args);
}, CONTAINER_NAME.BYTE);
var getImageInfo$6 = getImageInfo$5;

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var previewImage$5 = normalize.previewImage(function (args) {
  tt.previewImage(_extends$5({}, args, {
    current: typeof args.current === 'number' ? args.urls[args.current] : args.urls[0]
  }));
}, CONTAINER_NAME.BYTE);
var previewImage$6 = previewImage$5;

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var saveImage$5 = normalize.saveImage(function (args) {
  tt.saveImageToPhotosAlbum(_extends$4({}, args, {
    filePath: args.url
  }));
}, CONTAINER_NAME.BYTE);
var saveImage$6 = saveImage$5;

var bytedanceModule = {
  chooseImage: chooseImage$6,
  compressImage: compressImage$3,
  getImageInfo: getImageInfo$6,
  previewImage: previewImage$6,
  saveImage: saveImage$6
};

var chooseImage$3 = normalize.chooseImage(function (args) {
  return ks.chooseImage(args);
}, CONTAINER_NAME.KWAI);
var chooseImage$4 = chooseImage$3;

var compressImage$2 = normalize.compressImage(function (args) {
  args && typeof args.quality === 'number' && (args.quality *= 33);
  return ks.compressImage(args);
}, CONTAINER_NAME.KWAI);

var getImageInfo$3 = normalize.getImageInfo(function (args) {
  return ks.getImageInfo(args);
}, CONTAINER_NAME.KWAI);
var getImageInfo$4 = getImageInfo$3;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var previewImage$3 = normalize.previewImage(function (args) {
  ks.previewImage(_extends$3({}, args, {
    current: typeof args.current === 'number' ? args.urls[args.current] : args.urls[0]
  }));
}, CONTAINER_NAME.KWAI);
var previewImage$4 = previewImage$3;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var saveImage$3 = normalize.saveImage(function (args) {
  ks.saveImageToPhotosAlbum(_extends$2({}, args, {
    filePath: args.url
  }));
}, CONTAINER_NAME.KWAI);
var saveImage$4 = saveImage$3;

var kuaiShouModule = {
  chooseImage: chooseImage$4,
  compressImage: compressImage$2,
  getImageInfo: getImageInfo$4,
  previewImage: previewImage$4,
  saveImage: saveImage$4
};

var chooseImage$1 = normalize.chooseImage(function (args) {
  return swan.chooseImage(args);
}, CONTAINER_NAME.BAIDU);
var chooseImage$2 = chooseImage$1;

var compressImage$1 = normalize.compressImage(function (args) {
  args && typeof args.quality === 'number' && (args.quality *= 33);
  return swan.compressImage(args);
}, CONTAINER_NAME.BAIDU);

var getImageInfo$1 = normalize.getImageInfo(function (args) {
  return swan.getImageInfo(args);
}, CONTAINER_NAME.BAIDU);
var getImageInfo$2 = getImageInfo$1;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var previewImage$1 = normalize.previewImage(function (args) {
  swan.previewImage(_extends$1({}, args, {
    current: typeof args.current === 'number' ? args.urls[args.current] : args.urls[0]
  }));
}, CONTAINER_NAME.BAIDU);
var previewImage$2 = previewImage$1;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var saveImage$1 = normalize.saveImage(function (args) {
  swan.saveImageToPhotosAlbum(_extends({}, args, {
    filePath: args.url
  }));
}, CONTAINER_NAME.BAIDU);
var saveImage$2 = saveImage$1;

var baiDuModule = {
  chooseImage: chooseImage$2,
  compressImage: compressImage$1,
  getImageInfo: getImageInfo$2,
  previewImage: previewImage$2,
  saveImage: saveImage$2
};

var chooseImage = function chooseImage(args) {
  if (isWeb) {
    return webModule.chooseImage(args);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.chooseImage(args);
  } else if (isWeChatMiniProgram) {
    return weChatModule.chooseImage(args);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.chooseImage(args);
  } else if (isMiniApp) {
    return aliMiniAppModule.chooseImage(args);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.chooseImage(args);
  } else {
    throw new Error('Uni API：chooseImage暂不支持');
  }
};
var compressImage = function compressImage(args) {
  if (isWeb) {
    return webModule.compressImage();
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.compressImage(args);
  } else if (isWeChatMiniProgram) {
    return weChatModule.compressImage(args);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.compressImage(args);
  } else if (isMiniApp) {
    return aliMiniAppModule.compressImage(args);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.compressImage(args);
  } else {
    throw new Error('Uni API：compressImage暂不支持');
  }
};
var getImageInfo = function getImageInfo(args) {
  if (isWeb) {
    return webModule.getImageInfo(args);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.getImageInfo(args);
  } else if (isWeChatMiniProgram) {
    return weChatModule.getImageInfo(args);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.getImageInfo(args);
  } else if (isMiniApp) {
    return aliMiniAppModule.getImageInfo(args);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.getImageInfo(args);
  } else {
    throw new Error('Uni API：getImageInfo暂不支持');
  }
};
var previewImage = function previewImage(args) {
  if (isWeb) {
    return webModule.previewImage(args);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.previewImage(args);
  } else if (isWeChatMiniProgram) {
    return weChatModule.previewImage(args);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.previewImage(args);
  } else if (isMiniApp) {
    return aliMiniAppModule.previewImage(args);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.previewImage(args);
  } else {
    throw new Error('Uni API：previewImage暂不支持');
  }
};
var saveImage = function saveImage(args) {
  if (isWeb) {
    return webModule.saveImage();
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.saveImage(args);
  } else if (isWeChatMiniProgram) {
    return weChatModule.saveImage(args);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.saveImage(args);
  } else if (isMiniApp) {
    return aliMiniAppModule.saveImage(args);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.saveImage(args);
  } else {
    throw new Error('Uni API：saveImage暂不支持');
  }
};
var image = {
  chooseImage: chooseImage,
  compressImage: compressImage,
  getImageInfo: getImageInfo,
  previewImage: previewImage,
  saveImage: saveImage
};

export { compressImage as a, chooseImage as c, image as i, previewImage as p, saveImage as s };
